export function initProjectFilters(root = document) {
    root.querySelectorAll('.project-filters:not([data-pf-bound])').forEach(function (nav) {
        nav.dataset.pfBound = 'true';

        var btn = nav.querySelector('.pf-toggle');
        var panel = nav.querySelector('.pf-panel');
        var mobileQuery = window.matchMedia('(max-width: 48rem)');

        if (!btn || !panel) return;

        function setExpanded(isExpanded) {
            btn.setAttribute('aria-expanded', String(isExpanded));
            panel.classList.toggle('is-open', isExpanded);
            panel.setAttribute('aria-hidden', String(!isExpanded));
        }

        function syncState() {
            var isMobile = mobileQuery.matches;
            var expanded = btn.getAttribute('aria-expanded') === 'true';
            var labelledBy = isMobile ? panel.dataset.mobileLabelledby : panel.dataset.desktopLabelledby;

            if (labelledBy) {
                panel.setAttribute('aria-labelledby', labelledBy);
            }

            if (!isMobile) {
                panel.classList.remove('is-open');
                panel.setAttribute('aria-hidden', 'false');
                return;
            }

            setExpanded(expanded);
        }

        btn.addEventListener('click', function () {
            var expanded = btn.getAttribute('aria-expanded') === 'true';
            setExpanded(!expanded);
        });

        nav.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') return;
            if (mobileQuery.matches && btn.getAttribute('aria-expanded') === 'true') {
                setExpanded(false);
                btn.focus();
            }
        });

        if (typeof mobileQuery.addEventListener === 'function') {
            mobileQuery.addEventListener('change', syncState);
        } else if (typeof mobileQuery.addListener === 'function') {
            mobileQuery.addListener(syncState);
        }

        syncState();
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initProjectFilters();
    });
} else {
    initProjectFilters();
}
